import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-range-filter',
  templateUrl: './range-filter.component.html',
  styleUrls: ['./range-filter.component.scss'],
})
export class RangeFilterComponent {
  @Input() label: string;
  @Input() key: string;
  @Input() min: number;
  @Input() max: number;
  @Input() step: number;
  @Output() valueChange = new EventEmitter<{ min: number; max: number }>();

  minValue: FormControl = new FormControl();
  maxValue: FormControl = new FormControl();

  ngOnInit() {
    this.minValue.setValue(this.min);
    this.maxValue.setValue(this.max);
  }
  ngOnChanges() {
    this.reset();
  }

  checkValue(number) {
    console.log('Range: ', number);
  }
  onSliderChange() {
    this.valueChange.emit({ min: this.minValue.value, max: this.maxValue.value });
  }

  reset() {
    this.minValue.setValue(this.min);
    this.maxValue.setValue(this.max);
    this.onSliderChange();
  }
}
